import * as signalR from "@microsoft/signalr";
import vuexStore from './store'

let Vue: any;
let urlParams: any;
import Axios from "axios";

let eventsBatchTimeout:any = false;
let marketsBatchTimeout:any = false;
let orderBooksBatchTimeout:any = false;
let eventVolumeBatchTimeout:any = false;
let marketVolumeBatchTimeout:any = false;
let openBetsBatchTimeout:any = false;
let tickerBatchTimeout:any = false;
let eventsBatch : any[] =[];
let marketsBatch: any[] =[];
let orderBooksBatch: any[] =[];
let eventVolumeBatch: any[] =[];
let marketVolumeBatch: any[] =[];
let openBetsBatch: any[] =[];
let tickerBatch: any[] =[];

const wsConnection = new signalR.HubConnectionBuilder()
  .withUrl(process.env.VUE_APP_BACKEND_URL + "/feedhub", {
    skipNegotiation: true,
    transport: signalR.HttpTransportType.WebSockets
  })
  .withAutomaticReconnect()
  .configureLogging(signalR.LogLevel.Information)
  .build();


function startConnection() {
  wsConnection.start().then(response => {
    vuexStore.commit("setConnectedToBackend", true);
    vuexStore.commit("clearOpenBets");
    getInitialFeed()
  }).catch(err => {
    console.error(err.toString());
    vuexStore.commit("setConnectedToBackend", false);
    setTimeout(() => startConnection(), 5000);
  });
};

function getInitialFeed() {
  // "Brand" <= URL parameter Brand
  // "en-gb" <= URL parameter Language
  // "USD" <= URL parameter Currency
  // "" <= URL parameter Token
  // "eu" <= URL parameter LocalContext
  wsConnection.invoke("InitFeed", vuexStore.state.lastReceivedUpdate,
    urlParams.brandParam,
    urlParams.languageParam,
    urlParams.currencyParam,
    urlParams.tokenParam,
    urlParams.localisationContext?.replace("id", "in"),
    window.location.hostname).catch(err => console.error(err));
}

function recConnect() {
  startConnection();
}

wsConnection.on("N", (navigation) => {
  vuexStore.commit("initializeNavigation", {navigation: navigation, ws: wsConnection})
});
wsConnection.on("NU", (navigation) => {
  vuexStore.commit("updateNavigation", navigation)
});
wsConnection.on("EFF", (timestamp) => {
  console.log('Events Finished')
  vuexStore.commit("setInitialStateReady", timestamp)
});
wsConnection.on("EFS", (timestamp) => {
});

wsConnection.on("M", (market) => {
  if (!marketsBatchTimeout) {
    // clearTimeout(marketsBatchTimeout)
    marketsBatchTimeout = setTimeout(function () {
      console.log('Batched Markets ' + marketsBatch.length)
      vuexStore.commit("batchedUpdateMarkets", marketsBatch);

      marketsBatchTimeout = false;
      marketsBatch = [];
    }.bind(vuexStore), 100)

  }
  marketsBatch.push(market);
  // @ts-ignore
  //George comment/uncomment this to disable/enable Orderbook subscriptions
  // if (vuexStore.state.initialStateReady!=null && market.status != 'INACTIVE' && market.main && vuexStore.getters.getOrderbookSubscription(market.eventId,market.id)!=true) {
  //   wsConnection.invoke("SubscribeOrderbook", market.id)
  //   .then(response => {
  //     vuexStore.commit("setOrderbookActive", market)
  //   })
  //   .catch(err => console.error(err));
  // } else if (vuexStore.state.initialStateReady!=null && market.main && market.status == 'INACTIVE' && vuexStore.getters.getOrderbookSubscription(market.eventId,market.id)==true) {
  //   wsConnection.invoke("UnsubscribeOrderbook", market.id)
  //   .then(response => {
  //     vuexStore.commit("setOrderbookInactive", market)
  //   })
  //   .catch(err => console.error(err));
  // }
});

wsConnection.on("ER", (exchangeRate) => {

  vuexStore.commit("setUserCurrency", exchangeRate)
});

wsConnection.on("MS", (marketStop) => {

  vuexStore.commit("updateMarketsStatus", marketStop)
});

wsConnection.on("O", (orderbook) => {
  //console.log(orderbook);
  if (!orderBooksBatchTimeout) {
    // clearTimeout(orderBooksBatchTimeout)
    orderBooksBatchTimeout = setTimeout(function () {
      console.log('Batched OrderBooks ' + orderBooksBatch.length)
      vuexStore.commit("batchedSetOrderBook", orderBooksBatch);
      orderBooksBatchTimeout = false;
      orderBooksBatch = [];
    }.bind(vuexStore),500)

  }
  orderBooksBatch.push(orderbook);
  // @ts-ignore
  // vuexStore.commit("setOrderbook", orderbook)
});

wsConnection.on("U", (user) => {
  // console.log(user)
  vuexStore.commit("setUserInfo", user)
  if (user !== null && typeof user !== 'undefined' && user.token != null && user.token !== '') {
    Axios.defaults.headers.common = {'Authorization': `Bearer ${user.token}`}
  }
  if (user !== null && user.roles?.indexOf("Trader") > -1) {
    vuexStore.dispatch('getBotSupportedMarkets');
  }

});

wsConnection.on("MV", (volume) => {
  //console.log(volume);
  // vuexStore.commit("setMarketVolume",volume)
  if (!marketVolumeBatchTimeout) {
    // clearTimeout(marketVolumeBatchTimeout)
    marketVolumeBatchTimeout = setTimeout(function () {
      console.log('Batched Market Volumes ' + marketVolumeBatch.length)
      vuexStore.commit("batchedSetMarketVolume", marketVolumeBatch);
      marketVolumeBatchTimeout = false;
      marketVolumeBatch = [];
    }.bind(vuexStore), 50)

  }
  marketVolumeBatch.push(volume);
  // @ts-ignore
});

wsConnection.on("EV", (volume) => {
  if (!eventVolumeBatchTimeout) {
    // clearTimeout(eventVolumeBatchTimeout)
    eventVolumeBatchTimeout = setTimeout(function () {
      console.log('Batched Event Volumes ' + eventVolumeBatch.length)
      vuexStore.commit("batchedSetEventVolume", eventVolumeBatch);
      eventVolumeBatchTimeout = false;
      eventVolumeBatch = [];
    }.bind(vuexStore), 50)

  }
  eventVolumeBatch.push(volume);
  // @ts-ignore
  // vuexStore.commit("setEventVolume", volume)
});

wsConnection.on("SS", (serverStatus) => {


    vuexStore.commit("setFeedStatus", serverStatus);


});


wsConnection.on("EL", (lockdown) => {

  vuexStore.commit("setLockDown", lockdown);


});
wsConnection.on("E", (event) => {
  if (!eventsBatchTimeout) {
    // clearTimeout(eventsBatchTimeout)
    eventsBatchTimeout = setTimeout(function () {
      console.log('Batched Events ' + eventsBatch.length)
      vuexStore.commit("batchedUpdateEvents", eventsBatch);
      eventsBatchTimeout = false;
      eventsBatch = [];
    }.bind(vuexStore),500)

  }
  eventsBatch.push(event);
  // @ts-ignore
  // vuexStore.commit("updateEvents", event)
});

wsConnection.on("B", (bet) => {
  if(!openBetsBatchTimeout){
    // clearTimeout(openBetsBatchTimeout)
    openBetsBatchTimeout = setTimeout(function () {
      console.log('Batched Bets ' + openBetsBatch.length)
      vuexStore.commit("incrementOpenBetsBatchCounter");
      vuexStore.commit("batchedAddOpenBet", openBetsBatch);
      openBetsBatchTimeout = false;
      openBetsBatch = [];
    }.bind(vuexStore),500)

  }
  openBetsBatch.push(bet);
});


wsConnection.on("TMB", (traderMatchedBet) => {
  if(!tickerBatchTimeout){
    // clearTimeout(tickerBatchTimeout)
    tickerBatchTimeout = setTimeout(function () {
      console.log('Batched Ticker Bets ' + tickerBatch.length);
      vuexStore.commit("batchedAddTickerBets", tickerBatch);
      tickerBatchTimeout = false;
      tickerBatch = [];
    }.bind(tickerBatch),500);

  }
  tickerBatch.push(traderMatchedBet);});


wsConnection.on("MP", (marketPosition) => {
  console.log(marketPosition);
  vuexStore.commit('setMarketPositions', marketPosition)

});

wsConnection.onclose(() => {
  vuexStore.commit("setConnectedToBackend", false);
});

wsConnection.onreconnecting(() => {
  vuexStore.commit("setConnectedToBackend", false);
});

wsConnection.onreconnected(() => {
  vuexStore.commit("setConnectedToBackend", true);
  vuexStore.commit("clearOpenBets");
  getInitialFeed();
});

// Start the connection.
// startConnection();


async function boostrapConnection(VueInstance: any, urlParameters: any) {
  Vue = VueInstance
  urlParams = urlParameters;
  startConnection()
}

export default {
  boostrapConnection: boostrapConnection,
}
